module.exports = __webpack_public_path__ + "png/icon3.png?48a84b7b6e36eadb87b9c51a07a10faf";